import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#3ED8E6',
      main: '#211e4a',
      dark: '#4F6466',
      contrastText: '#ececec',
    },
    secondary: {
      light: '#D8F7FA',
      main: '#FF903E',
      dark: '#3C3733',
      contrastText: 'rgba(0, 0, 0, 0.06)',
    },
  },
});

const customTheme = createTheme({
  palette: {
    primary: {
      light: '#ececec',
      main: '#211e4a',
      contrastText: '#fff',
    },
  },
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ffffff',
    },
    background: {
      default: '#333333',
      paper: '#424242',
    },
    text: {
      primary: '#ffffff',
      secondary: '#bdbdbd',
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'white',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'white',
          },
        },
        input: {
          color: 'white',
        },
        notchedOutline: {
          borderColor: 'white',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'white',
        },
      },
    },
  },
});

export { theme, darkTheme, customTheme };
